/**
 * useDocumentDatabaseDetails Hook
 *
 * Custom React Query hook for fetching document database details.
 */

import { useQuery } from '@tanstack/react-query';
import { documentDatabaseService } from '../../../api/document-database.service';

/**
 * Hook for fetching document database details
 * @param tenantId - Tenant ID
 * @param documentDBId - DocumentDB ID
 */
export const useDocumentDatabaseDetails = (tenantId: string, documentDBId: string) => {
  return useQuery({
    queryKey: ['documentDatabases', tenantId, documentDBId],
    queryFn: async () => {
      const result = await documentDatabaseService.getDocumentDatabase(tenantId, documentDBId);
      return result;
    },
    enabled: !!tenantId && !!documentDBId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
